import React from "react";
import LabelWithInputDisabled from "../../../components/generic/LabelWithInputDisabled";
import MappingViewLink from "./MappingViewLink";
import "../../../styles/viewDetail.css";

function DbToDbView(props) {
  return (
    <div>
      <LabelWithInputDisabled
        label="Source test suite"
        value={props.testSuite}
      />
      <LabelWithInputDisabled
        label="Target test suite"
        value={props.testSuiteTwo}
      />
      <div className="vd-row">
        <span className="vd-label">Mapping</span>
        <span className="vd-value">
          <MappingViewLink
            mappingName={props.mappingName}
            mappingDetail={props.mappingDetail}
          />
        </span>
      </div>
    </div>
  );
}

export default DbToDbView;
